import React from 'react';
import { Building, DollarSign, Wrench } from 'lucide-react';

const CapitalGrantsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  capitalGrantPurposes 
}) => {
  if (!formData.includeCapitalGrants) return null;

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Building className="w-5 h-5 mr-2 text-blue-500" />
        Гранты на капитальные затраты
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма запрашиваемого гранта */}
        <div>
          <label htmlFor="capitalGrantsAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Запрашиваемая сумма гранта
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <DollarSign className="h-4 w-4 text-gray-500 dark:text-gray-400" />
            </div>
            <input
              type="text"
              id="capitalGrantsAmount"
              name="capitalGrantsAmount"
              value={formData.capitalGrantsAmount}
              onChange={handleInputChange}
              className={`form-input w-full pl-9 ${errors.capitalGrantsAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
          </div>
          {errors.capitalGrantsAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.capitalGrantsAmount}
            </p>
          )}
        </div>

        {/* Цель гранта */}
        <div>
          <label htmlFor="capitalGrantsPurpose" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Цель использования гранта
          </label>
          <select
            id="capitalGrantsPurpose"
            name="capitalGrantsPurpose"
            value={formData.capitalGrantsPurpose}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.capitalGrantsPurpose ? 'input-error' : ''}`}
          >
            {capitalGrantPurposes.map((purpose) => (
              <option key={purpose.id} value={purpose.id}>
                {purpose.name} ({purpose.fundingPercent}%)
              </option>
            ))}
          </select>
          {errors.capitalGrantsPurpose && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.capitalGrantsPurpose}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Wrench className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Информация о капитальных грантах
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Гранты на капитальные затраты предоставляются для приобретения оборудования, строительства 
              объектов и других капитальных вложений. Размер субсидии зависит от цели использования и может
              составлять от 40% до 70% от фактических затрат.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapitalGrantsSection;